import ApplicationFormCreate from '../../../pages/recruiting/applicationFormCreate/applicationFormCreate';


import SectionContent from '../../../components/sectionContent/sectionContent';
import HeaderBtn from '../../../components/headerBtn/headerBtn';
import Sidebar from '../../../components/sidebar/Sidebar';

import '../../../scss/App.scss';

const ApplicationFormCreateSection = () => {



	return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				section='Анкеты'
				pageName='vacancy'
				title='Создание анкеты'
				headBlockChildren={
					<>
						<HeaderBtn
							content='Сохранить'
							purpose='applicationCreate'
							modalTitle='Сохранить'
						/>
					</>
				}
			>
				<div className='content__single_report'>
					<div className='btns' style={{ margin: '0 0 7px 4px' }}>

					</div>
					<ApplicationFormCreate />

				</div>
			</SectionContent>
		</div>
	);
};

export default ApplicationFormCreateSection;
